export class Locality {
    id: number;
    name: string;
    latitude: number;
    longitude: number;
    address: string;
    
    constructor() { }
}